module.exports = __webpack_public_path__ + "img/all_documents.9dfc308e.svg";